document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.vc-audio-player').forEach(function (player) {
    var sourceEl = player.querySelector('source');
    if (!sourceEl) return;
    var titleEl = player.querySelector('.vc-audio-title');
    if (!titleEl) return;
    // Use data-title if set, otherwise generate from filename
    var customTitle = player.getAttribute('data-title');
    if (customTitle) {
      titleEl.textContent = 'Listen: ' + customTitle;
      return;
    }
    var name = sourceEl.src.split('/').pop().split('?')[0];
    name = name.replace('.m4a', '').replace('.mp3', '').replace('.ogg', '');
    name = name.replace(/_/g, ' ');
    name = name.replace(/versus/gi, 'vs');
    name = name.replace(/and/gi, '&');
    name = name.replace(/compared/gi, '');
    name = name.replace(/\s+/g, ' ').trim();
    name = name.replace(/\w/g, function (l) { return l.toUpperCase(); });
    titleEl.textContent = 'Listen: ' + name;
  });
});